import {Component, Input} from '@angular/core';
import {Events, NavParams, PopoverController} from "ionic-angular";
import moment from "moment";
import {CancelModalPage} from "../../pages/cancel-modal/cancel-modal";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";

/**
 * Generated class for the AdvertComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'booking-card',
    templateUrl: 'booking-card.html'
})
export class BookingCardComponent {

    @Input() booking;
    @Input() opacity;

    constructor(
      public events: Events,
      public popoverCtrl: PopoverController,
      public bookingService: BookingServiceProvider
    ) {

    }

    ngOnChanges(){

    }

    parseNumber(number){
      return Number(number);
    }

    getTotalCost(booking) {
      return this.bookingService.getTotalCost(booking);
    }

    openCancelBookingModal(booking) {
      this.bookingService.cancelBooking(booking).then(booking=>{
        this.booking = booking;
      });
    }

   public openRescheduleBookingModal(booking) : void{
      this.bookingService.reScheduleBooking(booking).then(booking=>{
        // this.booking = booking;
      });
    }

    public rebook(booking): void {
      this.bookingService.reScheduleBooking(booking).then(booking=>{
        // this.booking = booking;
      });
    }

}



// WEBPACK FOOTER //
// ./src/components/booking-card/booking-card.ts